import ApplicationSerializer from "./application";

export default class EmailAccountSerializer extends ApplicationSerializer {
  usesProxy = true;

  primaryKey = "emailaccount";

  normalizeArrayResponse(store, primaryModelClass, payload, id, requestType) {
    let normalizedPayload = {
      ...payload.response,
      emailaccounts: payload.response.list.emailaccounts,
    };

    delete normalizedPayload.list;

    return super.normalizeArrayResponse(store, primaryModelClass, normalizedPayload, id, requestType);
  }

  serialize(snapshot, options) {
    let payload = super.serialize(snapshot, options);

    if (payload.autorespondmessage === null) {
      delete payload.autorespondmessage;
    }

    return payload;
  }
}
